<div class="analytics-content">
  <b class="panel-heading">Growth</b>
  <nz-checkbox-wrapper style="width: 100%;" class="check-box-group">
    <div class="checkbox-extra-sm">
      <label
        nz-checkbox
        [ngModel]="tempModel.values.includes('YoY%')"
        (ngModelChange)="onChangeAnalyticInclusion('YoY%', $event)"
        class="checkbox-label"
        >Year over Year (%)</label
      >
    </div>
    <div class="checkbox-extra-sm">
      <label
        nz-checkbox
        [ngModel]="tempModel.values.includes('YoY#')"
        (ngModelChange)="onChangeAnalyticInclusion('YoY#', $event)"
        class="checkbox-label"
        >Year over Year (#)</label
      >
    </div>
    <div class="checkbox-extra-sm">
      <label
        nz-checkbox
        [ngModel]="tempModel.values.includes('Seq%')"
        (ngModelChange)="onChangeAnalyticInclusion('Seq%', $event)"
        class="checkbox-label"
        >Sequential growth (%)</label
      >
    </div>
    <div class="checkbox-extra-sm">
      <label
        nz-checkbox
        [ngModel]="tempModel.values.includes('Seq#')"
        (ngModelChange)="onChangeAnalyticInclusion('Seq#', $event)"
        class="checkbox-label"
        >Sequential growth (#)</label
      >
    </div>
    <div class="checkbox-extra-sm" style="position: relative;">
      <label
        nz-checkbox
        [ngModel]="tempModel.values.includes('Trend')"
        (ngModelChange)="onChangeAnalyticInclusion('Trend', $event)"
        class="checkbox-label"
        >Compare to (%)</label
      >
      <nz-select
        *ngIf="tempModel.values.includes('Trend')"
        [nzSize]="'small'"
        [(ngModel)]="tempModel.trendYear"
        (ngModelChange)="handleTrendChange()"
        [nzDropdownClassName]="'analytics-select-dropdown'"
      >
        <nz-option
          *ngFor="let yearItem of yearList"
          [nzValue]="yearItem.year"
          [nzLabel]="yearItem.label"
        ></nz-option>
      </nz-select>
    </div>
    <div class="checkbox-extra-sm" *ngIf="showAsPctOfOption">
      <label
        nz-checkbox
        [ngModel]="tempModel.values.includes('%')"
        (ngModelChange)="onChangeAnalyticInclusion('%', $event)"
        class="checkbox-label"
        title="As % of {{ showAsPctOfOption }}"
        ><span class="analytics-label"
          >As % of {{ showAsPctOfOption | textEllipsis: 20 }}</span
        ></label
      >
    </div>
  </nz-checkbox-wrapper>
  <div class="actions">
    <button
      [disabled]="actionsDisabled"
      nz-button
      nzType="default"
      nzSize="small"
      (click)="handleCancel()"
    >
      Cancel
    </button>
    <button
      id="options-refresh-buttons-apply-GrowthTypes"
      [disabled]="actionsDisabled"
      nz-button
      nzType="primary"
      nzSize="small"
      (click)="handleApply($event)"
    >
      Apply
    </button>
  </div>
</div>
